import api from "../api/axios"

export const getCourses = () => api.get("/courses").then((r) => r.data)
export const createCourse = (data) => api.post("/courses", data).then((r) => r.data)
export const updateCourse = (id, data) => api.put(`/courses/${id}`, data).then((r) => r.data)
export const deleteCourse = (id) => api.delete(`/courses/${id}`).then((r) => r.data)
